<!-- #2984 modified by ngx-extended-pdf-viewer -->
<!-- PDF.js v5.4.530+ uses #viewsManagerContent as the scrollable container -->
<div id="viewsManagerContent" tabindex="-1">
  <div id="thumbnailsView" (keydown)="onKeyDown($event)"></div>
  <!-- #3113 modified by ngx-extended-pdf-viewer - Add treeView class for proper outline/layers tree styling -->
  <div id="outlinesView" class="treeView hidden"></div>
  <div id="attachmentsView" class="hidden"></div>
  <div id="layersView" class="treeView hidden"></div>
  <!-- #3113 end of modification by ngx-extended-pdf-viewer -->
</div>
<!-- #2984 end of modification by ngx-extended-pdf-viewer -->

<!-- #3111 modified by ngx-extended-pdf-viewer -->
<!-- Updated to match PDF.js v5.4.530+ structure: direct div with checkbox + img (no anchor wrapper) -->
<!-- Note: page-number attribute (not data-page-number) is used by PDF.js v5.4.530+ -->
<ng-template #defaultThumbnail>
  <div class="thumbnail pdf-viewer-template" page-number="PAGE_NUMBER">
    <input type="checkbox" tabindex="-1" />
    <img class="thumbnailImage" role="button" tabindex="-1" alt="miniature of the page" />
  </div>
</ng-template>
<!-- #3111 end of modification by ngx-extended-pdf-viewer -->
